<template>
  <div @click="toggle" class="m-k__c m-k__c_first" data-toogle-markup=".m-k__row_offer">
    <div class="m-k__off-head">
      <div class="m-k__off-name">
        <a
            :href="`/marketplace/dashbaord/offer-info/${producer.type}/${offer.offer.id}`"
            data-modal>
          {{ offer.offer.title }}
        </a>
        <span>
          ℹ️
        </span>
        <TheSearchPanel :query="getModelOfferName()"/>
      </div>
      <div class="m-k__off-avails">
        <span title="Сейчас в наличии">
          {{ getLastOffer(objectToArray(offer)).quantity }}
        </span> /
        <span title="Продаж за последние 10 дней">
            пр: {{ offer.sold }}
        </span>
      </div>
    </div>

    <div class="m-k__info">
      ID: {{ offer.offer.id }}<br/>
      <span v-if="getLastOffer(objectToArray(offer))">
        Закупочная: {{ getLastOffer(objectToArray(offer)).incomingPrice }}<br/>
        Крупный опт: {{ getLastOffer(objectToArray(offer)).wholesalePrice }}<br/>
        Количество: {{ getLastOffer(objectToArray(offer)).quantity }}<br/><br/>
      </span>
      <span v-for="storeTail in offer.storeTails">
        {{ storeTail.storeName }}: {{ storeTail.quantity }}<br/>
      </span>
    </div>
  </div>

  <div v-for="column in this.data.columns.filter(c => !c.disable)"
       :class="['m-k__c', getColumnClasses(column)]"
  >
    <div class="m-k__w">
        <span
            class="m-k__perc"
            :class="{ '_low': getPercent(column, offer, data.markups.percents) < 0 }"
        >
            {{ getPercent(column, offer, this.data.markups.percents) }}%
        </span>
        <form class="m-k__markup-form" data-mark-form autocomplete="off"
              :data-marketplace="column.marketplaceKey"
              :data-seller="column.sellerId"
              :data-type="producer.type"
              :data-offer-id="offer.offer.id"
        >
          <div class="m-k__inputs">
            <input type="number"
                   name="value"
                   step="0.01"
                   autocomplete="off"
                   placeholder="закуп"
                   :id="['_value_', getId(column, offer)].join('')"
                   :value="getMarkup('incoming', column, offer)"
                   @keyup.enter.prevent="submit($event)"
                   @keyup.shift.enter.prevent="rowSubmit($event)"
                   @keyup.shift.delete.prevent="rowClear($event)"
            >

            <input type="number"
                   name="value_wholesale"
                   step="0.01"
                   autocomplete="off"
                   placeholder="кр.опт"
                   :id="['_value_wholesale_', getId(column, offer)].join('')"
                   :value="getMarkup('wholesale', column, offer)"
                   @keyup.enter.prevent="submit($event)"
                   @keyup.shift.enter.prevent="rowSubmit($event)"
                   @keyup.shift.delete.prevent="rowClear($event)"
            >
          </div>
        </form>
    </div>

    <div class="m-k__info" v-if="getExportOfferByMpAndSeller(offer, column)">
      Продажа: {{ getExportOfferByMpAndSeller(offer, column).sellingPrice }} <br/>
      Выгрузка: {{  getExportOfferByMpAndSeller(offer, column).resultPrice}}<br/>
      Дата обновления: {{  getCleanTime(getExportOfferByMpAndSeller(offer, column).createdAt) }}<br/><br/>
      Закупочная: {{ getExportOfferByMpAndSeller(offer, column).incomingPrice}}<br/>
      Крупный опт: {{ getExportOfferByMpAndSeller(offer, column).wholesalePrice}}<br/>
      <form class="m-k__options-form"
            :data-marketplace="column.marketplaceKey"
            :data-seller="column.sellerId"
            :data-type="producer.type"
            :data-offer-id="offer.offer.id"
      >
        <input type="checkbox"
               value="1"
               :checked="isAllowLowerRetail(getOfferByMpAndSeller(offer, column))"
               :id="['_check_',getId(column, offer)].join('')"
               name="allow_lower_retail"
               @change="sendOptionForm($event)"
        ><span></span>
        <label :for="['_check_',getId(column, offer)].join('')">
          ниже розн.
        </label>
      </form>
    </div>
  </div>
</template>

<script>
import {mapState} from "pinia";
import {useMarkupsStore} from "../../stores/markups";
import {markupsMixin} from "../../mixins/markupsMixin";
import TheSearchPanel from "./TheSearchPanel.vue";
import moment from "moment";

export default {
  name: "TheOfferLine",
  components: {TheSearchPanel},
  computed: {
    ...mapState(useMarkupsStore, [
      'data'
    ]),
  },
  props: ['offer', 'model', 'producer'],
  mixins: [markupsMixin],
  methods: {
    getPercent(column, offer, percents) {
      const key = this.getId(column, offer);
      return percents[key] ? percents[key] : 0;
    },
    getModelOfferName() {
      return this.model.modelName + ' ' + this.offer.offer.title;
    },
    getLastOffer(offer) {
      return offer[0].exportOffer;
    },
    getExportOfferByMpAndSeller(offer, column) {
      const key = column.marketplaceKey + '-' + column.sellerId;
      if (offer.collection[key]) {
        return offer.collection[key].exportOffer;
      }
    },
    getOfferByMpAndSeller(offer, column) {
      const key = column.marketplaceKey + '-' + column.sellerId;
      if (offer.collection[key]) {
        return offer.collection[key];
      }
    },
    getId(column, offer) {
      return ['o',column.marketplaceKey, column.sellerId, offer.offer.id].join('-');
    },
    getMarkup(type, column, offer) {
      const key = this.getId(column, offer);

      const getMarkupProperty = (markup) => {
        if (type === 'wholesale') return markup.percentWholesale;
        if (type === 'incoming') return markup.percent;
      };

      for (const markup of offer.markups) {
        const markupKey = ['o', markup.marketplace, markup.seller, markup.offerId].join('-');

        if (key === markupKey) {
          return getMarkupProperty(markup);
        }
      }

      return null;
    },
    getCleanTime(stringTime) {
      const date = moment(stringTime)
      return date.format('yyyy.MM.DD HH:mm:ss');
    },
    isAllowLowerRetail(offer) {
      let result = false
      if (offer.offerOptions) {
        result = offer.offerOptions.allowSellLowerThanRetail
      }
      return result;
    },
  }
}
</script>